import React from 'react';

import './style.scss';

function ConductorSep(){
  return (
    <div
      className="conductor-sep"
    />
  );
}

export default ConductorSep;